export default __webpack_public_path__ + "static/media/logo-stt.711ac799.svg";